module.exports = __webpack_public_path__ + "img/icb-leo-Adv-m@3x.595ac435.png";